import { QueryKey } from '@/configs/queryKeys';
import APP_CONFIG from '@/configs/appConfig';
import { Language } from '@/types/types';
import {
	AppContent,
	checkIfExist,
	getText,
} from '@/utils/contentLookup';

function getContentFromStorage(): AppContent {
	if (typeof localStorage === 'undefined') return {};
	try {
		const stored = localStorage.getItem(QueryKey.content);
		if (!stored) return {};
		return JSON.parse(stored) as AppContent;
	} catch {
		return {};
	}
}

function getLanguageFromStorage(): Language {
	if (typeof localStorage === 'undefined') return APP_CONFIG.DEFAULT_LANGUAGE as Language;
	try {
		const stored = localStorage.getItem('language');
		if (!stored) return APP_CONFIG.DEFAULT_LANGUAGE as Language;
		return JSON.parse(stored) as Language;
	} catch {
		return APP_CONFIG.DEFAULT_LANGUAGE as Language;
	}
}

export function getContent(
	slug: string,
	options?: { vars?: Record<string, string | number> }
): string {
	const content = getContentFromStorage();
	const language = getLanguageFromStorage();

	if (!checkIfExist(content, slug, language, APP_CONFIG.DEFAULT_LANGUAGE)) return slug;

	return getText(content, slug, language, APP_CONFIG.DEFAULT_LANGUAGE, options?.vars);
}
